(function () {
    'use strict';
    
    window.run = {
        parts: {},
        pages: {},
        admin: {
            parts: {},
            pages: {}    
        },
        superadmin: {
            parts: {},
            pages: {}    
        }
    };
})();